import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { Compiler } from '@angular/core';


@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent {

  
  constructor(
    private meta:Meta,
  ){
   
  }



  test(){

    const shareUrl = 'http://etl.beinex.com/'; // Replace with your link URL
    const shareTitle = 'Check out this cool website!'; // Replace with your title

    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl
    )}&title=${encodeURIComponent(shareTitle)}`;

    window.open(
      facebookShareUrl,
      'facebook-share-dialog',
      'width=600,height=400'
    );
  }


  changeMeta(){
    this.meta.updateTag( { name:'twitter:title', content:'New Meta Discription'},"name='twitter:title'");
    this.meta.updateTag( { property:'og:title', content:'New Meta Discription'},"property='og:title'");
  }
}
